import { render } from "./StudentsBirthday.vue?vue&type=template&id=017eab48"
import script from "./StudentsBirthday.vue?vue&type=script&lang=js"
export * from "./StudentsBirthday.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__